import React from 'react'

export function PlusIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      fill="none"
      viewBox="0 0 25 24"
    >
      <path
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2.0"
        d="M12.5 3v9m0 9v-9m0 0h9m-9 0h-9"
      />
    </svg>
  )
}
